var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"has-background":true,"contained":true}},[_c('div',[_c('ShipmentDetailsComponent',{attrs:{"id":_vm.$route.params.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }